/* VastuCity theme scripts (vanilla JS, no dependencies) */
(function () {
  'use strict';

  /* Mobile menu */
  var toggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.getElementById('mobile-nav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      mobileNav.hidden = open;
      var o = toggle.querySelector('[data-icon-open]');
      var c = toggle.querySelector('[data-icon-close]');
      if (o && c) { o.hidden = !open; c.hidden = open; }
    });
  }

  /* Mulank finder */
  var PLANETS = ['', 'Sun', 'Moon', 'Jupiter', 'Rahu', 'Mercury', 'Venus', 'Ketu', 'Saturn', 'Mars'];
  document.querySelectorAll('[data-mulank]').forEach(function (root) {
    var input = root.querySelector('[data-mulank-input]');
    var empty = root.querySelector('[data-mulank-empty]');
    var found = root.querySelector('[data-mulank-found]');
    var num = root.querySelector('[data-mulank-number]');
    var name = root.querySelector('[data-mulank-name]');
    var link = root.querySelector('[data-mulank-link]');
    var base = root.getAttribute('data-collections-url') || '/collections';
    var prefix = root.getAttribute('data-prefix') || 'driver-';
    function update() {
      var d = parseInt(input.value, 10);
      if (!(d >= 1 && d <= 31)) { empty.hidden = false; found.hidden = true; return; }
      var m = d;
      while (m > 9) { m = String(m).split('').reduce(function (a, c) { return a + Number(c); }, 0); }
      num.textContent = m;
      name.textContent = 'Mulank ' + m + ' · ' + PLANETS[m];
      link.textContent = 'See the Driver-' + m + ' collection';
      link.href = base.replace(/\/$/, '') + '/' + prefix + m;
      empty.hidden = true; found.hidden = false;
    }
    input.addEventListener('input', update);
  });

  /* Collection filters: submit on change */
  document.querySelectorAll('[data-filter-form]').forEach(function (form) {
    form.addEventListener('change', function () { form.submit(); });
  });

  /* Password recovery toggle */
  var rec = document.querySelector('[data-recover-toggle]');
  if (rec) {
    rec.addEventListener('click', function (e) {
      e.preventDefault();
      var box = document.getElementById('recover');
      if (box) { box.hidden = !box.hidden; }
    });
  }
  if (location.hash === '#recover') {
    var rb = document.getElementById('recover');
    if (rb) { rb.hidden = false; }
  }

  /* Delete address confirmation */
  document.querySelectorAll('[data-confirm-delete]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      if (!window.confirm('Delete this address?')) { e.preventDefault(); }
    });
  });

  /* Product page */
  function initProduct(section) {
    var currency = section.getAttribute('data-currency') || 'INR';
    var variantsEl = section.querySelector('[data-variants]');
    var form = section.querySelector('[data-product-form], form.product-form');
    if (!variantsEl || !form) { return; }
    var variants = JSON.parse(variantsEl.textContent);
    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = section.querySelector('[data-price]');
    var compareEl = section.querySelector('[data-compare]');
    var offEl = section.querySelector('[data-off]');
    var buttons = [].slice.call(document.querySelectorAll('[data-add],[data-buy-now],[data-add-sticky],[data-buy-sticky]'));
    var track = section.querySelector('[data-gallery-track]');
    var count = section.querySelector('[data-gallery-count]');
    var thumbs = [].slice.call(section.querySelectorAll('[data-thumb]'));

    function money(cents) {
      try {
        return (cents / 100).toLocaleString('en-IN', { style: 'currency', currency: currency, maximumFractionDigits: (cents % 100 === 0) ? 0 : 2 });
      } catch (e) { return (cents / 100).toFixed(2); }
    }

    function selected() {
      return [].slice.call(form.querySelectorAll('.option')).map(function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === null || o === opts[i]; });
      });
    }

    function refreshAvailability() {
      /* Disable option values that cannot lead to any available variant */
      var opts = selected();
      [].slice.call(form.querySelectorAll('.option')).forEach(function (fs, idx) {
        fs.querySelectorAll('input').forEach(function (inp) {
          var test = opts.slice(); test[idx] = inp.value;
          var exists = variants.some(function (v) {
            return v.options.every(function (o, i) { return test[i] === null || o === test[i]; });
          });
          inp.disabled = !exists;
        });
      });
    }

    function setButtons(v) {
      buttons.forEach(function (b) {
        var isAdd = b.hasAttribute('data-add') || b.hasAttribute('data-add-sticky');
        b.disabled = !(v && v.available);
        if (isAdd) { b.textContent = (v && v.available) ? 'Add to cart' : 'Sold out'; }
      });
    }

    function scrollToMedia(v) {
      if (!track || !v || !v.featured_media) { return; }
      var slide = track.querySelector('[data-media-id="' + v.featured_media.id + '"]');
      if (slide) { track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' }); }
    }

    function onChange() {
      var v = findVariant(selected());
      refreshAvailability();
      if (!v) { setButtons(null); return; }
      idInput.value = v.id;
      if (priceEl) { priceEl.textContent = money(v.price); }
      if (compareEl && offEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price); compareEl.hidden = false;
          offEl.textContent = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '% off'; offEl.hidden = false;
        } else { compareEl.hidden = true; offEl.hidden = true; }
      }
      setButtons(v);
      scrollToMedia(v);
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    form.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio') { onChange(); }
    });
    refreshAvailability();

    /* Gallery counter + thumbs */
    if (track) {
      var slides = [].slice.call(track.querySelectorAll('.gallery-slide'));
      function activeIndex() {
        var w = track.clientWidth || 1;
        return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / w)));
      }
      track.addEventListener('scroll', function () {
        var i = activeIndex();
        if (count) { count.textContent = (i + 1) + ' / ' + slides.length; }
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      }, { passive: true });
      thumbs.forEach(function (t, k) {
        t.addEventListener('click', function () {
          if (slides[k]) { track.scrollTo({ left: slides[k].offsetLeft - track.offsetLeft, behavior: 'smooth' }); }
        });
      });
      if (thumbs[0]) { thumbs[0].classList.add('is-active'); }
    }
  }
  document.querySelectorAll('[data-product-section]').forEach(initProduct);

  /* Product recommendations */
  document.querySelectorAll('[data-recs]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url || !window.fetch) { return; }
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-recs]');
      if (fresh && fresh.innerHTML.trim().length) { el.innerHTML = fresh.innerHTML; }
    }).catch(function () { /* keep empty */ });
  });
})();
